export var DocsPageAnchorType;
(function (DocsPageAnchorType) {
    DocsPageAnchorType[DocsPageAnchorType["SMALL"] = 0] = "SMALL";
    DocsPageAnchorType[DocsPageAnchorType["REGULAR"] = 1] = "REGULAR";
    DocsPageAnchorType[DocsPageAnchorType["LARGE"] = 2] = "LARGE";
})(DocsPageAnchorType || (DocsPageAnchorType = {}));
//# sourceMappingURL=DocsPageAnchorType.js.map